/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React, { Component } from 'react';
import PropTypes from "prop-types";
import moment from "moment";

export class PCSLogComponent extends Component{
    static get propTypes() {
        return {
            logs: PropTypes.array.isRequired,
            getPCSLogs: PropTypes.func.isRequired
        };
    }

    componentDidMount(){
        this.props.getPCSLogs();
    }

    render(){
        const logs = this.props.logs.filter(log => log.isACXML === false);
        return(
            <div  className="pe-row view-pcs-log-container">
                <div className="pe-col-12">
                    <h3 className="header">PDH Log Status</h3>
                    {logs.map((log)=><div className="log-item">
                        <p><strong>PDH Status</strong> {log.status?log.status: '--'} <strong>on</strong> {log.responseTime? moment(log.responseTime).format( "YYYY-MM-DD HH:mm:ss") : '--'}</p>
                    </div>)}
                    {logs.length === 0 && <div>No Logs Found!</div>}
                </div>
            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/BookContainerComponents/PCSLogComponent.js